import { CompanyMetadata } from '@blisspointmedia/bpm-types/dist/LogsTracker';
import { Design, Intent } from '@Components/designConstants';

export const LOGS_TRACKER_PATH = '/logs-tracker';

export const LogType = {
  PRE: 'pre',
  POST: 'post'
} as const;
export type LogTypeType = (typeof LogType)[keyof typeof LogType];

export const LOG_TYPE_LABELS: Record<LogTypeType, string> = {
  [LogType.PRE]: 'Pre Logs',
  [LogType.POST]: 'Post Logs'
};

// The view is the URL sub-path: /logs-tracker shows both lanes, /logs-tracker/pre and
// /logs-tracker/post focus one. The legacy /logs/pre and /logs/post URLs redirect here.
export const View = {
  BOTH: 'both',
  ...LogType
} as const;
export type ViewType = (typeof View)[keyof typeof View];

export const VIEW_OPTIONS = [
  { key: View.BOTH, label: 'Both' },
  { key: View.PRE, label: 'Pre' },
  { key: View.POST, label: 'Post' }
];

export const LogStatus = {
  NOT_STARTED: 'not-started',
  IN_PROGRESS: 'in-progress',
  COMPLETED: 'completed'
} as const;
export type LogStatusType = (typeof LogStatus)[keyof typeof LogStatus];

// In Progress leads because it holds the networks that still need follow-up.
export const STATUS_ORDER: LogStatusType[] = [
  LogStatus.IN_PROGRESS,
  LogStatus.NOT_STARTED,
  LogStatus.COMPLETED
];

export const STATUS_LABELS: Record<LogStatusType, string> = {
  [LogStatus.NOT_STARTED]: 'Not Started',
  [LogStatus.IN_PROGRESS]: 'In Progress',
  [LogStatus.COMPLETED]: 'Completed'
};

export const STATUS_BADGE_DESIGN = {
  [LogStatus.NOT_STARTED]: Design.NEUTRAL,
  [LogStatus.IN_PROGRESS]: Intent.WARNING,
  [LogStatus.COMPLETED]: Intent.SUCCESS
} as const satisfies Record<LogStatusType, string>;

// One row per planned (network, company) pair, as returned by GET /logs_tracker.
export interface LogsTrackerRow {
  network: string;
  company: string;
  network_notes: string | null;
  company_notes: string | null;
  checked: boolean | null;
  didNotRun: boolean | null;
}

// Unsaved edits, keyed like NetworkMap. POST /update_logs_tracker only writes the fields present.
export interface NetworkEdit {
  networkNotes?: string;
  companies?: Record<string, Partial<CompanyMetadata>>;
}
export type NetworkEdits = Record<string, NetworkEdit>;
